@let corporateDesign = corporateDesignService.corporateDesign();
@let fontColor =
  corporateDesignService.isDarkModeActive()
    ? corporateDesign.colorAdmixtures.dark_text_high
    : '';
@let texts = textStore.texts();
@if (corporateDesign && !configurationStore.isLoading() && !isLoading()) {
  <aw-section
    class="w-full"
    testIdAffix="account-form"
    [formGroup]="accountInfoForm"
    [darkModeColor]="corporateDesign.colorAdmixtures.dark_surface_01">
    <h2
      class="text-3xl font-semibold"
      [style.color]="fontColor"
      [attr.data-testid]="'account-form-account-info-headline'">
      {{
        texts
          | filterTexts: ERelationType.userInfo : EEntityType.privateArea
          | language
      }}
    </h2>
    <aw-section
      testIdAffix="account-info-description"
      [attr.data-testid]="'account-form-account-info-description-section'"
      [darkModeColor]="corporateDesign.colorAdmixtures.dark_surface_02">
      <quill-view
        [style.color]="fontColor"
        [content]="
          texts
            | filterTexts
              : ERelationType.descriptionText
              : EEntityType.privateArea
            | language
        "
        [attr.data-testid]="'account-form-account-info-description-section'"
        format="json"
        theme="snow"></quill-view>
    </aw-section>

    <aw-section
      testIdAffix="account-info-foto"
      [attr.data-testid]="'account-form-account-info-photo-section'"
      [darkModeColor]="corporateDesign.colorAdmixtures.dark_surface_02">
      <h3
        class="text-2xl font-semibold"
        [attr.data-testid]="'account-form-account-info-photo-headline'"
        [style.color]="fontColor">
        {{
          texts
            | filterTexts: ERelationType.headlinePhoto : EEntityType.privateArea
            | language
        }}
      </h3>
      <div class="flex w-full flex-row justify-center">
        <div
          [attr.data-testid]="'account-form-account-info-photo-preview'"
          [style.background-color]="
            corporateDesignService.isDarkModeActive()
              ? corporateDesign.colorAdmixtures.dark_surface_end
              : ''
          "
          [ngClass]="{
            'border-standard-outline-light border-1':
              !corporateDesignService.isDarkModeActive(),
          }"
          class="flex h-56 w-56 flex-row items-center justify-center rounded-full">
          @if (!this.imageFileForm.controls.imageURL.value) {
            <span
              [style.color]="
                corporateDesignService.isDarkModeActive()
                  ? corporateDesign.colorAdmixtures.dark_text
                  : corporateDesign.primaryColor
              "
              [attr.data-testid]="'account-form-account-info-photo-empty-icon'"
              class="material-symbols-rounded text-[128px]!">
              {{
                configurationStore.getStringConfiguration(
                  CONFIGURATION_SETTING_KEYS.PictureIcon
                )
              }}
            </span>
          } @else {
            <img
              [src]="this.imageFileForm.controls.imageURL.value"
              [attr.data-testid]="'account-form-account-info-photo-preview-image'"
              class="rounded-full"
              alt="profile-picture" />
          }
        </div>
      </div>
      <div class="py-2">
        <quill-view
          [style.color]="fontColor"
          [content]="
            texts
              | filterTexts
                : ERelationType.descriptionPhotoText
                : EEntityType.privateArea
              | language
          "
          [attr.data-testid]="'account-form-account-info-photo-description'">
          format="json" theme="snow"></quill-view
        >
      </div>
      <aw-button
        id="account-info-photo-upload"
        type="button"
        (click)="uploader.click()"
        >{{
          texts
            | filterTexts
              : ERelationType.uploadButtonText
              : EEntityType.privateArea
            | language
        }}</aw-button
      >
      <aw-button
        [style]="'primary-alt'"
        id="account-info-photo-delete"
        (click)="deleteProfilePicture()"
        type="button"
        >{{
          texts
            | filterTexts
              : ERelationType.deleteButtonText
              : EEntityType.privateArea
            | language
        }}</aw-button
      >
      <div>
        <h3
          class="pt-6 pb-4 text-2xl font-semibold"
          [style.color]="fontColor"
          [attr.data-testid]="'account-form-account-info-personal-data-headline'">
          {{
            texts
              | filterTexts
                : ERelationType.personalDataHeading
                : EEntityType.generalArea
              | language
          }}
        </h3>
        <div class="flex flex-col gap-4">
          <aw-drop-down
            id="account-info-salutation"
            [darkModeLabelColor]="
              corporateDesign.colorAdmixtures.dark_text_disabled
            "
            [options]="salutationOptions() | toTranslatedOption"
            [label]="
              texts
                | filterTexts
                  : ERelationType.newCustomerSalutation
                  : EEntityType.generalArea
                | language
            "
            formControlName="salutation"
            >Fehler</aw-drop-down
          >
          <aw-text-input
            id="account-info-first-name"
            [darkModeLabelColor]="
              corporateDesign.colorAdmixtures.dark_text_disabled
            "
            [label]="
              texts
                | filterTexts
                  : ERelationType.newCustomerFirstName
                  : EEntityType.generalArea
                | language
            "
            formControlName="firstName"
            >Fehler</aw-text-input
          >
          <aw-text-input
            id="account-info-last-name"
            [darkModeLabelColor]="
              corporateDesign.colorAdmixtures.dark_text_disabled
            "
            [label]="
              texts
                | filterTexts
                  : ERelationType.newCustomerLastName
                  : EEntityType.generalArea
                | language
            "
            formControlName="lastName"
            >Fehler</aw-text-input
          >
          <aw-date-input
            id="account-info-date-of-birth"
            [darkModeLabelColor]="
              corporateDesign.colorAdmixtures.dark_text_disabled
            "
            [label]="
              texts
                | filterTexts
                  : ERelationType.personalDataBirthdate
                  : EEntityType.generalArea
                | language
            "
            formControlName="dateOfBirth"
            >Fehler</aw-date-input
          >
          <aw-text-input
            id="account-info-email"
            [darkModeLabelColor]="
              corporateDesign.colorAdmixtures.dark_text_disabled
            "
            [label]="
              texts
                | filterTexts
                  : ERelationType.accountDataEmail
                  : EEntityType.generalArea
                | language
            "
            formControlName="email"
            >Fehler</aw-text-input
          >
          <aw-text-input
            id="account-info-phone-number"
            [darkModeLabelColor]="
              corporateDesign.colorAdmixtures.dark_text_disabled
            "
            [label]="
              texts
                | filterTexts
                  : ERelationType.newCustomerTelephone
                  : EEntityType.generalArea
                | language
            "
            formControlName="phoneNumber"
            >Fehler</aw-text-input
          >
        </div>
        <h3
          class="pt-6 pb-4 text-2xl font-semibold"
          [style.color]="fontColor"
          [attr.data-testid]="'account-form-account-info-address-headline'">
          {{
            texts
              | filterTexts
                : ERelationType.addressDataHeading
                : EEntityType.generalArea
              | language
          }}
        </h3>
        <div class="-mx-2 flex flex-row flex-wrap">
          <aw-auto-complete
            class="p-2"
            [darkModeLabelColor]="
              corporateDesign.colorAdmixtures.dark_text_disabled
            "
            [options]="availableCountries()"
            name="name"
            valueAttribute="isoCode"
            id="account-info-country"
            [label]="
              texts
                | filterTexts
                  : ERelationType.addressDataCountry
                  : EEntityType.generalArea
                | language
            "
            formControlName="country"
            >Fehler</aw-auto-complete
          >
          <aw-text-input
            class="p-2 md:w-2/12"
            [darkModeLabelColor]="
              corporateDesign.colorAdmixtures.dark_text_disabled
            "
            id="account-info-city-code"
            [label]="
              texts
                | filterTexts
                  : ERelationType.addressDataPostalCode
                  : EEntityType.generalArea
                | language
            "
            formControlName="cityCode"
            >Fehler</aw-text-input
          >
          <aw-text-input
            class="p-2 md:w-10/12"
            [darkModeLabelColor]="
              corporateDesign.colorAdmixtures.dark_text_disabled
            "
            id="account-info-city"
            [label]="
              texts
                | filterTexts
                  : ERelationType.addressDataCity
                  : EEntityType.generalArea
                | language
            "
            formControlName="city"
            >Fehler</aw-text-input
          >
          <aw-text-input
            class="p-2 md:w-10/12"
            [darkModeLabelColor]="
              corporateDesign.colorAdmixtures.dark_text_disabled
            "
            id="account-info-street"
            [label]="
              texts
                | filterTexts
                  : ERelationType.addressDataStreet
                  : EEntityType.generalArea
                | language
            "
            formControlName="street"
            >Fehler</aw-text-input
          >
          <aw-text-input
            class="p-2 md:w-2/12"
            [darkModeLabelColor]="
              corporateDesign.colorAdmixtures.dark_text_disabled
            "
            id="account-info-street-number"
            [label]="
              texts
                | filterTexts
                  : ERelationType.addressDataHouseNumber
                  : EEntityType.generalArea
                | language
            "
            formControlName="streetNumber"
            >Fehler</aw-text-input
          >
          <aw-text-input
            class="p-2"
            [darkModeLabelColor]="
              corporateDesign.colorAdmixtures.dark_text_disabled
            "
            id="account-info-street-number-suffix"
            [label]="
              texts
                | filterTexts
                  : ERelationType.addressDataExtra
                  : EEntityType.generalArea
                | language
            "
            formControlName="streetNumberSuffix"
            >Fehler</aw-text-input
          >
        </div>
      </div>
    </aw-section>
    <aw-button
      [isDisabled]="!accountInfoForm.valid"
      [disabledText]="
        texts
          | filterTexts
            : ERelationType.saveButtonTextDisabled
            : EEntityType.privateArea
          | language
      "
      (keyup.enter)="save()"
      (click)="save()"
      id="account-info-save"
      type="button"
      >{{
        texts
          | filterTexts: ERelationType.saveButtonText : EEntityType.privateArea
          | language
      }}</aw-button
    >
  </aw-section>
  <input
    [attr.data-testid]="'upload-file' | appendTestId: 'input'"
    [id]="'image-upload'"
    type="file"
    hidden
    #uploader
    [multiple]="false"
    accept="image/tiff, image/png, image/gif, image/jpeg, image/jpg"
    (change)="selectFileEvent($event)" />
} @else {
  <div class="flex h-full flex-row items-center justify-center">
    <aw-loading-animation
      [relationType]="ERelationType.loading"
      [entityType]="EEntityType.privateArea"></aw-loading-animation>
  </div>
}
